import script from "./MemberList.vue?vue&type=script&lang=ts&setup=true"
export * from "./MemberList.vue?vue&type=script&lang=ts&setup=true"

import "./MemberList.vue?vue&type=style&index=0&id=056b1148&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-056b1148"]])

export default __exports__